<template>
  <div class="search">
    <i class="icon-search"></i>
    <input v-model="model" placeholder="Search" type="text" />
  </div>
</template>

<script>
export default {
  name: 'FundingSearch',
  props: {
    value: {
      required: true
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  background-color: #fff;
  display: flex;
  align-items: center;
  overflow: hidden;

  i {
    flex: 0 0 auto;
    padding: 12px 0 15px 25px;
  }

  input {
    width: 100%;
    flex: 1 1 auto;
    border: none;
    height: 52px;
    padding: 0 15px 0 10px;
    outline: none;
  }
}
</style>
